<template>
  <AuthLayout
    active-tab="login"
    title="Köszöntünk a kényelmes<br>könyvelés világában!"
  >
    <form class="auth-form" @submit.prevent="login">
      <div class="auth-field">
        <label for="login-email">Email</label>
        <input
          v-model="email"
          id="login-email"
          type="email"
          placeholder="minta@gmail.com"
          autocomplete="email"
          required
        />
      </div>

      <div class="auth-field">
        <div class="auth-label-row mt-3">
          <label for="login-password">Jelszó</label>
          <router-link to="/forgotten-password" tabindex="-1" class="font-jumperlight">Elfelejtetted?</router-link>
        </div>
        <div class="password-control">
          <input
            v-model="password"
            id="login-password"
            :type="showPassword ? 'text' : 'password'"
            autocomplete="current-password"
            required
          />
          <button
            type="button"
            class="password-toggle"
            aria-label="Jelszó láthatóság váltása"
            @click="showPassword = !showPassword"
          >
            <i v-if="showPassword" class="fal fa-eye-slash"></i>
            <i v-else class="fal fa-eye"></i>
          </button>
        </div>
      </div>

      <button class="auth-submit" type="submit">Bejelentkezés</button>
    </form>

    <div v-if="showRegistrationSuccessModal" class="registration-success-modal-backdrop">
      <div class="registration-success-modal">
        <div class="registration-success-icon" aria-hidden="true"></div>
        <h2>Siker!</h2>
        <p>
          Az ingyenes próbaidőszak alatt, a szoftvert és az ügyfélszolgálatot tudod kipróbálni minden kötelezettség nélkül. Nyugi, meghatalmazás hiányában adóbevallást nem fogunk benyújtani Neked, mindaddig, amíg könyvelési szerződést nem kötsz velünk, illetve könyvelői meghatalmazást nem adsz számunkra!
        </p>
        <button
          type="button"
          class="registration-success-modal-button"
          @click="showRegistrationSuccessModal = false"
        >
          Rendben
        </button>
      </div>
    </div>
  </AuthLayout>
</template>

<script>
import Api from "api-client";
import { localeOptions } from "../../constants/config";
import { mapActions } from "vuex";
import AuthLayout from "@/components/AuthLayout.vue";
import Util from "@/utils/Util";
import { measureRegistrationCompletedIfArmed } from "@/utils/OpenAiAds";

export default {
  components: { AuthLayout },
  data() {
    return {
      email: "",
      password: "",
      showPassword: false,
      localeOptions,
      newAccountUrl: "",
      showRegistrationSuccessModal: false,
    };
  },
  methods: {
    ...mapActions("app", ["changeLocale"]),
    ...mapActions("app", ["login"]),

    setLocale(locale) {
      this.changeLocale(locale);
    },

    afterSuccessFulLogin(auth, isAutoLogin) {
      let self = this;
      Api.getMyEnabledCompanies()
        .then((companyResponse) => {
          self.$store.dispatch("app/addCompanyList", companyResponse.data);
          document.title = "Acounto";
          self.$router.push("/app/home/" + new Date().valueOf());
        })
        .catch(() => {
          !isAutoLogin
            ? self.$toast.error({
                title: self.$cte("login.companiesQueryFailedTitle"),
                message: self.$cte("login.companiesQueryFailedMessage"),
              })
            : null;
        });
      self.$store.dispatch("login/login", auth);
    },

    login() {
      let loginRequest = {
        email: this.email,
        password: this.password,
        screenWidth: window.screen.width,
        screenHeight: window.screen.height,
      };

      Api.login(loginRequest)
        .then((resp) => {
          if (!resp.data || !resp.data.jwtToken) {
            console.error("hibás login", resp);
            this.$store.dispatch("login/logout");
          } else {
            Util.storeLastSuccessfulLoginEmail(this.email);
            this.afterSuccessFulLogin(`Bearer ${resp.data.jwtToken}`, false);
          }
        })
        .catch((error) => {
          console.error("sikertelen login", error);
          this.$toast.error({
            title: this.$cte("login.loginFailed"),
            message: this.$cte("login.loginFailedDescription"),
          });
          this.$store.dispatch("login/logout");
        });
    },
    autoLogin() {
      let self = this;
      if (self.$route.query.auth) {
        self.afterSuccessFulLogin(self.$route.query.auth, true);
      }
    },
  },
  watch: {
    "$i18n.locale"(to, from) {
      if (from !== to) {
        this.$router.go(this.$route.path);
      }
    },
  },
  created() {
    let self = this;
    document.title = self.$cte("profile.loginDocTitle");
    self.$store.dispatch("login/logout");
    self.email = Util.getLastSuccessfulLoginEmail();
    self.newAccountUrl = process.env.VUE_APP_NEW_ACCOUNT;
    self.showRegistrationSuccessModal = self.$route.path === "/success-reg";
    if (self.showRegistrationSuccessModal) {
      measureRegistrationCompletedIfArmed();
    }
    self.autoLogin();
  },
};
</script>

<style scoped lang="scss">
@media (min-width: 577px) {
  ::v-deep(.auth-title) {
    margin-top: 40px;
  }
}

.auth-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.auth-field label,
.auth-label-row a {
  margin: 0 0 10px 24px;
  color: #000 !important;
  font-family: JumperLight, sans-serif;
  font-size: 16px;
  line-height: 1;
}

.auth-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.auth-label-row a {
  margin-right: 22px;
  color: #8a8a8a !important;
  text-decoration: none;
}

.auth-label-row a.font-jumperlight {
  font-family: JumperLight, sans-serif !important;
}

.auth-field input,
#app .auth-field input {
  width: 100%;
  height: 40px !important;
  margin: 0 !important;
  padding: 0 20px !important;
  border: 1px solid #aebfc7 !important;
  border-radius: 999px !important;
  background: rgba(255, 255, 255, 0.6) !important;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1) !important;
  color: #252734 !important;
  font-family: Poppins, sans-serif;
  font-size: 15px !important;
}

.password-control {
  position: relative;
}

.password-control input,
#app .password-control input {
  padding-right: 68px !important;
}

.password-toggle {
  position: absolute;
  top: 50%;
  right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  transform: translateY(-50%);
  border: 0;
  background: transparent;
  color: #252734;
  font-size: 18px;
  line-height: 1;
}

.auth-submit {
  width: 100%;
  min-height: 60px;
  margin-top: clamp(28px, 5vh, 44px);
  border: 0;
  border-radius: 999px;
  background: #b2ec5d;
  box-shadow: 0 20px 30px rgba(0, 0, 0, 0.1);
  color: #252734;
  font-family: JumperLight, sans-serif;
  font-size: clamp(24px, 1.8vw, 32px);
  line-height: 1;
}

.registration-success-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(3px);
}

.registration-success-modal {
  width: min(100%, 560px);
  max-height: calc(100vh - 48px);
  overflow-y: auto;
  padding: 38px 44px 36px;
  border-radius: 30px;
  background: #ffffff;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.18);
  text-align: center;
}

.registration-success-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 86px;
  height: 86px;
  margin-bottom: 34px;
  border: 5px solid #b2ec5d;
  border-radius: 50%;
}

.registration-success-icon::after {
  width: 42px;
  height: 22px;
  border-bottom: 6px solid #b2ec5d;
  border-left: 6px solid #b2ec5d;
  content: "";
  transform: rotate(-45deg) translate(4px, -3px);
}

.registration-success-modal h2 {
  margin: 0 0 24px;
  color: #000000;
  font-family: JumperBold, sans-serif;
  font-size: 38px;
  line-height: 1;
}

.registration-success-modal p {
  max-width: 560px;
  margin: 0 auto 38px;
  color: #252734;
  font-family: Poppins, sans-serif;
  font-size: 19px;
  font-weight: 300;
  line-height: 1.45;
}

.registration-success-modal-button {
  width: min(100%, 420px);
  min-height: 58px;
  border: 0;
  border-radius: 999px;
  background: #b2ec5d;
  box-shadow: 0 20px 30px rgba(0, 0, 0, 0.1);
  color: #252734;
  font-family: JumperBold, sans-serif;
  font-size: 26px;
  line-height: 1;
}

@media (max-width: 576px) {
  .auth-label-row a,
  .auth-field label {
    margin-left: 16px;
    margin-right: 16px;
    font-size: 16px;
  }

  .auth-submit {
    min-height: 70px;
    margin-top: 32px;
  }

  .registration-success-modal-backdrop {
    padding: 24px 28px;
  }

  .registration-success-modal {
    padding: 32px 24px 30px;
    border-radius: 26px;
  }

  .registration-success-icon {
    width: 76px;
    height: 76px;
    margin-bottom: 28px;
    border-width: 5px;
  }

  .registration-success-icon::after {
    width: 36px;
    height: 19px;
    border-bottom-width: 5px;
    border-left-width: 5px;
  }

  .registration-success-modal h2 {
    margin-bottom: 20px;
    font-size: 34px;
  }

  .registration-success-modal p {
    margin-bottom: 32px;
    font-size: 17px;
  }

  .registration-success-modal-button {
    min-height: 54px;
    font-size: 24px;
  }
}
</style>
